import { CONSORS_NOBILITY_TITLES } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsNobilityTitle = z.nativeEnum(CONSORS_NOBILITY_TITLES);
